import useMultiLanguageSignIn from 'page/Authentication/SignIn/hook/useMultiLanguageSignIn';
import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';
import errorIcon from '../../../assets/logo/error-confirm-signup-email.svg'
import BtnSubmitFullSize from 'page/Authentication/component/Button/BtnSubmitFullSize';
import ImageIcon from 'page/Authentication/component/Image';

const ErrorConfirmSignupEmail = () => {
  const { MAINTENANCE_MESSAGE } = useMultiLanguageSignIn();

  // start get maintenance information
  const [yyyy, setyyyy] = useState();
  const [MM, setMM] = useState();
  const [dd, setdd] = useState();
  const [hh, sethh] = useState();
  const [mm, setmm] = useState();
  const [isMaintenance, setMaintenance] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('./maintenancetimeconfig.json');
        const jsonData = await response.json();
        setyyyy(jsonData.yyyy);
        setMM(jsonData.MM);
        setdd(jsonData.dd);
        sethh(jsonData.hh);
        setmm(jsonData.mm);
        setMaintenance(jsonData.isMaintenance);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData().then();
  }, []);

  const message = MAINTENANCE_MESSAGE.replace('{yyyy}', yyyy)
    .replace('{MM}', MM)
    .replace('{dd}', dd)
    .replace('{hh}', hh)
    .replace('{mm}', mm);

  const formattedMessage = message.split('\n').map((str, index, arr) => (
    <span key={index}>
      {str}
      {index < arr.length - 1 && <br />}
    </span>
  ));

  return (
    <div className="form-responsive">
      {isMaintenance && (
        <Alert
          message={formattedMessage}
          type="error"
          style={{ paddingLeft: '30px' }}
        />
      )}
      <div className="form-confirm-signup-email">
        <ImageIcon src={errorIcon} alt={'error icon'} />
        <p className="title">このURLは無効です。</p>
        <p className="description description1">
          URLが間違っているか
          <br />
          有効期限が過ぎている可能性があります。
        </p>
        <p className="description description2">
          本人確認メールを確認してください。
        </p>
        <BtnSubmitFullSize
          formName="error-confirm-signup-email"
          isMaintenance={isMaintenance}
          isShowLinkText={false}
          isNavigateButton={true}
        />
      </div>
    </div>
  );
};

export default ErrorConfirmSignupEmail;
